// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__j7AF_","additionalInfo":"AgreementModal_additionalInfo__2b4SF"};